"use strict";
/* globals module */
/**
 * @module mediaGalleryBatchClient
 * @description  Media Gallery Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var MediaGalleryBatchClient = /** @class */ (function () {
    function MediaGalleryBatchClient(mediaGalleryBatchRoute, apiClient) {
        this.mediaGalleryBatchRoute = mediaGalleryBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaGalleryBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGalleryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified media gallery resources.
     * @method
     * @param data A collection of media gallery objects used to update specified media gallery resources.
     * @returns A promise that is resolved once the update action has been performed.
     * @example mediaGalleryStreamsClient.update(files)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    MediaGalleryBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove media gallery resources from the system if successfully completed. Specified media galleries and all accompanying derived resources will be removed from the system.
     * @method
     * @param ids Collection of media gallery Id which uniquely identifies media gallery resources that need to be deleted.
     * @example // Remove original media gallery resources
                        mediaGalleryBatchClient.remove([<media-gallery-id>])
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    MediaGalleryBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.mediaGalleryBatchRoute.delete(), undefined, ids);
    };
    /**
    * Returns a promise that is resolved once the create action has been performed; this action creates specified media gallery resources.
    * @method
    * @param data A collection of media gallery objects used to create specified media gallery resources.
    * @returns A promise that is resolved once the create action has been performed.
    * @example mediaGalleryStreamsClient.create(files)
                  .then(function (data) {
                      // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                  });
   **/
    MediaGalleryBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    MediaGalleryBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGalleryBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGalleryBatchRoute !== "undefined" && _1.MediaGalleryBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaGalleryBatchClient);
    return MediaGalleryBatchClient;
}());
exports.MediaGalleryBatchClient = MediaGalleryBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
